<template>
    <!-- 简介 -->
    <div class="des_contain">
        <div class="content_box">
            {{description}}
        </div>
        <div class="look_detail-box" v-if="isLookDetail !== -1">
            <div class="look_detail" @click="clickLookDetail">{{lookDetailData}}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'audioBookDetailDes',
    props: {
        description:{
            type:String,
            default:'',
        }
    },
    data() {
        return {
            bookDesData: '',
            lookDetailData: '',
            isLookDetail: -1,
        }
    },
}
</script>

<style scoped>
.des_contain{
    width:100vw;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    box-sizing: border-box;

}
.content_box{
    width:93%;
    font-size: 16px;
    line-height: 20px;
    box-sizing: border-box;
    padding-top:10px;

}
.look_detail-box{
    width:93%;
    height: 30px;
    display:flex;
    flex-direction: row-reverse;
    align-items: center;
    box-sizing: border-box;
}
.look_detail{
    height:30px;
    line-height: 30px;
    font-size: 15px;
    color: RGBA(79, 173, 248, 1);
    box-sizing: border-box;
}

</style>
